import { motion } from 'motion/react';

const ProgressBarMotion = ({
  children,
  className = '',
  disabled = false,
  duration = 0.25,
  ease = 'easeInOut',
  dynamicWidth = 0,
  style = {},
}) => {
  return (
    <motion.div
      className={className}
      initial={{ width: 0 }}
      animate={{ width: `${dynamicWidth}%` }}
      transition={{
        duration: disabled ? 0 : duration,
        ease,
      }}
      style={style}>
      {children}
    </motion.div>
  );
};

export default ProgressBarMotion;
